import { Injectable } from '@angular/core';
import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidationRulesService {
  required(): ValidatorFn[] {
    return [Validators.required];
  }

  plate(): ValidatorFn[] {
    return [Validators.required, Validators.pattern(/^[A-Za-z]{3}[0-9]{3}$/)];
  }

  documentNumber(minLength = 5): ValidatorFn[] {
    return [
      Validators.required,
      Validators.pattern(new RegExp(`^\\d{${minLength},}$`)),
      Validators.maxLength(15),
    ];
  }

  password(): ValidatorFn[] {
    return [
      Validators.required,
      Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/),
    ];
  }

  phone(): ValidatorFn[] {
    return [Validators.required, Validators.pattern(/^\d{10,10}$/)];
  }

  email(): ValidatorFn[] {
    return [
      Validators.required,
      Validators.email,
      Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/),
    ];
  }

  address(): ValidatorFn[] {
    return [Validators.required, Validators.minLength(8), Validators.maxLength(100)];
  }

  numericRange(min: number, max: number): ValidatorFn[] {
    return [Validators.required, Validators.min(min), Validators.max(max)];
  }

  minLength(length: number): ValidatorFn[] {
    return [Validators.required, Validators.minLength(length)];
  }

  maxLength(length: number): ValidatorFn[] {
    return [Validators.required, Validators.maxLength(length)];
  }

  requiredTrue(): ValidatorFn[] {
    return [Validators.requiredTrue];
  }

  resolveFirstError(
    control: AbstractControl<unknown, unknown>,
    messages: Record<string, string>,
  ): string {
    if (!control.errors) {
      return '';
    }

    if (!control.touched && !control.dirty) {
      return '';
    }
    const firstError = Object.keys(control.errors)[0];
    return messages[firstError] ?? 'Dato inválido.';
  }

  hasError(control: AbstractControl<unknown, unknown>): boolean {
    return control.touched && !!control.errors;
  }

  atLeastOneSelected(values: string[]): ValidationErrors | null {
    return values.length > 0 ? null : { atLeastOne: true };
  }

  validationForSelect(allowedValues: () => string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === undefined) return null;
      const isValid = allowedValues()
        .map((item) => item.toString())
        .includes(control.value.toString());
      return isValid ? null : { select: true };
    };
  }
}
